import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import {
  Row,
  Col,
  Select,
  Input,
  Checkbox,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';

import {
  SpH5,
  SpError,
} from 'components/DesignKit';

const { Option } = Select;

type Props = {
  serviceInfo: Object,
  shopData: Array,
};

const ServiceType = (props: Props, ref) => {
  const {
    serviceInfo,
    shopData,
  } = props;

  const [, forceUpdate] = useState();
  const [serviceType, setServiceType] = useState(serviceInfo.serviceType);
  const [serviceTypes, setServiceTypes] = useState([
    {
      checked: false,
      gid: '',
      val: '',
    },
    {
      checked: false,
      gid: '',
      val: '',
    },
    {
      checked: false,
      gid: '',
      val: '',
    },
    {
      checked: false,
      gid: '',
      val: '',
    },
    {
      checked: false,
      gid: '',
      val: '',
    },
    {
      checked: false,
      gid: '',
      val: '',
    },
  ]);
  const simpleValidator = useRef(new SimpleReactValidator());

  useEffect(() => {
    if (serviceInfo?.serviceTypes?.length > 0) {
      setServiceTypes(serviceInfo?.serviceTypes);
    }
  }, [serviceInfo]);

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      serviceInfo.serviceType = serviceType;
      serviceInfo.serviceTypes = serviceTypes;
      return true;
    },
  }));

  return (
    <>
      <div>
        <Row>
          <Col span={6} className="mb-2">
            <SpH5>Service Header Text</SpH5>
          </Col>
        </Row>
        <Row>
          <Col span={6}>
            <Input
              type="text"
              value={serviceType}
              maxLength={30}
              onChange={(e) => {
                setServiceType(e.currentTarget.value);
                serviceInfo.serviceType = e.currentTarget.value;
              }}
            />
            <SpError>
              {simpleValidator.current.message('service header text', serviceType, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col span={6} className="mb-2">
            <SpH5>Service Type (Up to 6)</SpH5>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6} className="mr-3 d-flex" justify="middle">
            <Checkbox
              className="mr-2"
              checked={serviceTypes[0].checked}
              onChange={({ target: { checked } }) => {
                const list = [...serviceTypes];
                list[0].checked = checked;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
            <Input
              type="text"
              maxLength={15}
              value={serviceTypes[0].val}
              disabled={!serviceTypes[0].checked}
              onChange={(e) => {
                const list = [...serviceTypes];
                list[0].val = e.currentTarget.value;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
          </Col>
          <Col span={4}>
            {
              (shopData && shopData.length > 1) && (
                <Col>
                  <Select
                    style={{
                      width: '350px',
                      marginRight: '5px',
                    }}
                    placeholder="select shop"
                    onSelect={(e) => {
                      const list = [...serviceTypes];
                      list[0].gid = e;
                      setServiceTypes(list);
                      serviceInfo.serviceTypes = list;
                    }}
                    showSearch
                    value={serviceTypes[0].gid || 'Select shop'}
                  >
                    {
                      shopData.map(item => (
                        <Option
                          key={item.gid}
                          value={item.gid}
                        >
                          {item.gid}
                        </Option>
                      ))
                    }
                  </Select>
                </Col>
              )
            }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6} className="mr-3 d-flex" justify="middle">
            <Checkbox
              className="mr-2"
              checked={serviceTypes[1].checked}
              onChange={({ target: { checked } }) => {
                const list = [...serviceTypes];
                list[1].checked = checked;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
            <Input
              type="text"
              value={serviceTypes[1].val}
              disabled={!serviceTypes[1].checked}
              onChange={(e) => {
                const list = [...serviceTypes];
                list[1].val = e.currentTarget.value;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
          </Col>
          <Col span={4}>
            {
              (shopData && shopData.length > 1) && (
                <Col>
                  <Select
                    style={{
                      width: '350px',
                      marginRight: '5px',
                    }}
                    placeholder="select shop"
                    onSelect={(e) => {
                      const list = [...serviceTypes];
                      list[1].gid = e;
                      setServiceTypes(list);
                      serviceInfo.serviceTypes = list;
                    }}
                    showSearch
                    value={serviceTypes[1].gid || 'Select shop'}
                  >
                    {
                      shopData.map(item => (
                        <Option
                          key={item.gid}
                          value={item.gid}
                        >
                          {item.gid}
                        </Option>
                      ))
                    }
                  </Select>
                </Col>
              )
            }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6} className="mr-3 d-flex" justify="middle">
            <Checkbox
              className="mr-2"
              checked={serviceTypes[2].checked}
              onChange={({ target: { checked } }) => {
                const list = [...serviceTypes];
                list[2].checked = checked;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
            <Input
              type="text"
              value={serviceTypes[2].val}
              disabled={!serviceTypes[2].checked}
              onChange={(e) => {
                const list = [...serviceTypes];
                list[2].val = e.currentTarget.value;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
          </Col>
          <Col span={4}>
            {
              (shopData && shopData.length > 1) && (
                <Col>
                  <Select
                    style={{
                      width: '350px',
                      marginRight: '5px',
                    }}
                    placeholder="select shop"
                    onSelect={(e) => {
                      const list = [...serviceTypes];
                      list[2].gid = e;
                      setServiceTypes(list);
                      serviceInfo.serviceTypes = list;
                    }}
                    showSearch
                    value={serviceTypes[2].gid || 'Select shop'}
                  >
                    {
                      shopData.map(item => (
                        <Option
                          key={item.gid}
                          value={item.gid}
                        >
                          {item.gid}
                        </Option>
                      ))
                    }
                  </Select>
                </Col>
              )
            }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6} className="mr-3 d-flex" justify="middle">
            <Checkbox
              className="mr-2"
              checked={serviceTypes[3].checked}
              onChange={({ target: { checked } }) => {
                const list = [...serviceTypes];
                list[3].checked = checked;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
            <Input
              type="text"
              value={serviceTypes[3].val}
              disabled={!serviceTypes[3].checked}
              onChange={(e) => {
                const list = [...serviceTypes];
                list[3].val = e.currentTarget.value;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
          </Col>
          <Col span={4}>
            {
              (shopData && shopData.length > 1) && (
                <Col>
                  <Select
                    style={{
                      width: '350px',
                      marginRight: '5px',
                    }}
                    placeholder="select shop"
                    onSelect={(e) => {
                      const list = [...serviceTypes];
                      list[3].gid = e;
                      setServiceTypes(list);
                      serviceInfo.serviceTypes = list;
                    }}
                    showSearch
                    value={serviceTypes[3].gid || 'Select shop'}
                  >
                    {
                      shopData.map(item => (
                        <Option
                          key={item.gid}
                          value={item.gid}
                        >
                          {item.gid}
                        </Option>
                      ))
                    }
                  </Select>
                </Col>
              )
            }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6} className="mr-3 d-flex" justify="middle">
            <Checkbox
              className="mr-2"
              checked={serviceTypes[4].checked}
              onChange={({ target: { checked } }) => {
                const list = [...serviceTypes];
                list[4].checked = checked;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
            <Input
              type="text"
              value={serviceTypes[4].val}
              disabled={!serviceTypes[4].checked}
              onChange={(e) => {
                const list = [...serviceTypes];
                list[4].val = e.currentTarget.value;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
          </Col>
          <Col span={4}>
            {
              (shopData && shopData.length > 1) && (
                <Col>
                  <Select
                    style={{
                      width: '350px',
                      marginRight: '5px',
                    }}
                    placeholder="select shop"
                    onSelect={(e) => {
                      const list = [...serviceTypes];
                      list[4].gid = e;
                      setServiceTypes(list);
                      serviceInfo.serviceTypes = list;
                    }}
                    showSearch
                    value={serviceTypes[4].gid || 'Select shop'}
                  >
                    {
                      shopData.map(item => (
                        <Option
                          key={item.gid}
                          value={item.gid}
                        >
                          {item.gid}
                        </Option>
                      ))
                    }
                  </Select>
                </Col>
              )
            }
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6} className="mr-3 d-flex" justify="middle">
            <Checkbox
              className="mr-2"
              checked={serviceTypes[5].checked}
              onChange={({ target: { checked } }) => {
                const list = [...serviceTypes];
                list[5].checked = checked;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
            <Input
              type="text"
              value={serviceTypes[5].val}
              disabled={!serviceTypes[5].checked}
              onChange={(e) => {
                const list = [...serviceTypes];
                list[5].val = e.currentTarget.value;
                setServiceTypes(list);
                serviceInfo.serviceTypes = list;
              }}
            />
          </Col>
          <Col span={4}>
            {
              (shopData && shopData.length > 1) && (
                <Col>
                  <Select
                    style={{
                      width: '350px',
                      marginRight: '5px',
                    }}
                    placeholder="select shop"
                    onSelect={(e) => {
                      const list = [...serviceTypes];
                      list[5].gid = e;
                      setServiceTypes(list);
                      serviceInfo.serviceTypes = list;
                    }}
                    showSearch
                    value={serviceTypes[5].gid || 'Select shop'}
                  >
                    {
                      shopData.map(item => (
                        <Option
                          key={item.gid}
                          value={item.gid}
                        >
                          {item.gid}
                        </Option>
                      ))
                    }
                  </Select>
                </Col>
              )
            }
          </Col>
        </Row>
      </div>
    </>
  );
};

export default forwardRef(ServiceType);
